ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let flagDiscountMatch = true;
    var TierObject = '';
    var firstTimeLoad = '';
    var TierProducts = [];
    var TierMemberProducts = [];
    var additonalTierProducts = [];
    var discountFlag = false;
    var newCodeClick = true;
    var bundleTierCountSet = 0;
    var productsTypeArray = [];
    var sotertDisObj = [];
    var loadingCheck = false;
    var additionaltext = '';
    var merberTiers = [];
    var lodgeCoupan = false;
   var shopifyRate =  Number(Shopify.currency.rate);
       var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
        if (isUpdate) {
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
          if (isNotInRange || condition1) {
                jQuery('.price-list.hidden-phone').eq(index).html('<div ><span class="money revy-final-item-price" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
                jQuery('.line-item__price-list-container.text--right').eq(index).html('<div><span class="money revy-final-item-price" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
            }
            else {
                originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
               jQuery('.price-list.hidden-phone').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money revy-final-item-price" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
               jQuery('.line-item__price-list-container.text--right').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div><span class="money revy-final-item-price lastPriceFinal" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
               }
                          
        }
    } // Line Item Price Change

    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
               jQuery('#anncode-cart-subtotal-price').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
            else {
                jQuery('#anncode-cart-subtotal-price').html('<span id="anncode-cart-subtotal-price" class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
        }
      jQuery('.cart__discount-list.list--unstyled').remove()
    } // Subtotal Price

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
            if (jQuery(window).width() < 700) {

                jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__total-container,.mini-cart__actions').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
            }
            else {
                jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__total-container,.mini-cart__actions').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
            }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
      loadingCheck = true;
    } // SAVE Message

    var CheckoutClickCart = function () {
        jQuery('.cart__aside .cart__recap button[name="checkout"]').click(function () {
        jQuery('.checkout-buttonText').text('Loading...');
        jQuery('.cart__recap button[name="checkout"]').prop('disabled', true);
        GetCode(false);
  
        });
    } // Cart Page Checkout

    var CheckoutClickAjax = function () {
        jQuery('.mini-cart__drawer-footer button[name="checkout"]').click(function (e) {
            e.preventDefault();
            GetCode(true);
        });
    } // Drawer Ajax Popup  Checkout
  
     var isValueGreaterThanHighest = function (array, value) {

  // Convert array elements to numbers
   const numericArray = array.map(Number);

  // Find the highest value in the array
  const highestValue = Math.max(...numericArray);

  // Check if the passed value is greater than the highest value
  return value > highestValue;
}
  let marketregion = globalFields.CuurencyCode();
    // var GetCode = function (isUpper) {
    //     var addtionalDiscount = getCookie('additionalDiscount');
    //     if (priceDiff > 0) {
    //         jQuery.ajax({
    //             type: "POST", async: false, url: "http://localhost:8081/api/ACPGeneratedraftorderforMasonsBricks",
    //             data: { priceDifference: priceDiff, TierProductsarray: JSON.stringify(TierProducts), cartobject: JSON.stringify(globalFieldsCartPage_AC.cartObj), DiscountText: "", subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
    //             success: function (result) {
    //                 var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
    //                 var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
    //                 SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
    //                 if (!isUpper) {
    //                     var addtionalDiscount = getCookie('additionalDiscount');
    //                     if (addtionalDiscount != null) {
    //                         DiscountCode = `${DiscountCode},${addtionalDiscount}`
    //                     } else {
    //                         DiscountCode = `${DiscountCode}`
    //                     }
    //                     DiscountCodeCookie(DiscountCode);
    //                     jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
    //                     window.location.href = '/checkout?discount=' + DiscountCode;
    //                 }
    //                 else {
    //                     var addtionalDiscount = getCookie('additionalDiscount');
    //                     if (addtionalDiscount != null) {
    //                         DiscountCode = `${DiscountCode},${addtionalDiscount}`
    //                     } else {
    //                         DiscountCode = `${DiscountCode}`
    //                     }
    //                     DiscountCodeCookie(DiscountCode);
    //                     //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
    //                     window.location.href = '/checkout?discount=' + DiscountCode;
    //                 }
    //             },
    //             error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
    //         });
    //     } else if (addtionalDiscount != null) {
    //         var addtionalDiscount = getCookie('additionalDiscount');
    //         if (addtionalDiscount != null) {
    //             DiscountCode = `${addtionalDiscount}`
    //         }
    //         DiscountCodeCookie(DiscountCode);
    //         jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
    //         window.location.href = '/checkout?discount=' + DiscountCode;
    //     }
    //     else if (isUpper) {
    //         window.location.href = '/checkout';
    //     }
    //     else {
    //         window.location.href = '/checkout';
    //     }
    // } // DISCOUNT GENRATE FUNCTION

    var GetCode = function (isUpper) {
      
        var addtionalDiscount = getCookie('additionalDiscount');
        var additionalDiscountarray = getCookie('additionalDiscountarray');
      
        let checkDis = true;
        if(addtionalDiscount != null){
        if(addtionalDiscount.includes('FRIDAY60')){
          checkDis = false;
        }
        }
        if (priceDiff > 0 && checkDis) {
           let jsonDatavalue = JSON.stringify({priceDifference: priceDiff,AdditionalObj:(AdditonalDiscountObj),currencyRate:shopifyRate,cartAdditionalObj:(additionalDiscountarray), TierProductsarray: (TierProducts),TierMemberProductsarray:TierMemberProducts, cartItemsObj: (globalFieldsCartPage_AC.cartObj), DiscountText: additionaltext, subTotal: minimumDiscountSubtotal, MarketRegionCode:marketregion,variantIds: variantIdsToSend.toString() })
            jQuery.ajax({
                type: "POST", async: false, url: "https://wholesale.apptiv.in/api/ACPGeneratedraftorderforMasonsBricksMember",
                contentType: "application/json", // Set content type to JSON
                processData: false, 
                data:jsonDatavalue,
                  success: function(result) {
                  setTimeout(function() {
                  window.location.href = result;
                  },300);
                  },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
            });
        } else if (merberTiers.length > 0 && addtionalDiscount != null) {
           let jsonDatavalue = JSON.stringify({priceDifference: priceDiff,AdditionalObj:(AdditonalDiscountObj),currencyRate:shopifyRate,cartAdditionalObj:(additionalDiscountarray),TierProductsarray: (TierProducts),TierMemberProductsarray:TierMemberProducts, cartItemsObj: (globalFieldsCartPage_AC.cartObj), DiscountText: additionaltext, subTotal: minimumDiscountSubtotal, MarketRegionCode:marketregion,variantIds: variantIdsToSend.toString() })
            jQuery.ajax({
                type: "POST", async: false, url: "https://wholesale.apptiv.in/api/ACPGeneratedraftorderforMasonsBricksMember",
                contentType: "application/json", // Set content type to JSON
                processData: false, 
                data:jsonDatavalue,
                  success: function(result) {
                  setTimeout(function() {
                  window.location.href = result;
                  },300);
                  },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
            });
        }
        else if (addtionalDiscount != null) {
            var addtionalDiscount = getCookie('additionalDiscount');
            if (addtionalDiscount != null) {
                DiscountCode = `${addtionalDiscount}`
            }
            DiscountCodeCookie(DiscountCode);
            jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
            window.location.href = '/checkout?discount=' + DiscountCode;
        }
        else if (isUpper) {
            window.location.href = '/checkout';
        }
        else {
            window.location.href = '/checkout';
        }
    } // DISCOUNT GENRATE FUNCTION

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

    var matchTierObj = function (valueMatch, product_type) {
        let Tempobj = undefined;
        for (let jk = 0; jk < valueMatch.bundlewithDiscount.length; jk++) {
            if (valueMatch.bundlewithDiscount[jk].productType == product_type) {
                valueMatch.bundlewithDiscount[jk].tier_status = valueMatch.tier_status;
                Tempobj = valueMatch.bundlewithDiscount[jk];
                break;
            }
        }
        return Tempobj;
    } // Match   Bundle Object

   function calculateBundleCount(obj) {
  // Get an array of values
  const counts = Object.values(obj);

  // Find the minimum count among all items
  const minCount = Math.min(...counts);

  // The minimum count represents the number of bundles
  return minCount;
}
  
   var bundleGroup = function (arrayOfObjects, productTypesArray) {
    let bundleQuantities = {};
 var allProductTypesPresent = productTypesArray.every(type =>
            arrayOfObjects.some(obj => obj.product_type === type)
        );
    arrayOfObjects
        .filter(obj => productTypesArray.includes(obj.product_type))
        .forEach(obj => {
            const productType = obj.product_type;
            const quantity = parseInt(obj.quantity, 10);

            bundleQuantities[productType] = bundleQuantities[productType] || 0;
            bundleQuantities[productType] += quantity;
        });
     
    let count =  calculateBundleCount(bundleQuantities)
    return {count,allProductTypesPresent};
} // Match  bundleGroup Object

  var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
       return tierObj[0];
    }

  function findMatchingTier(productType, productVendor, tierMatchArray) {
    // var addtionalDiscount = getCookie('additionalDiscount');
    if (!Array.isArray(tierMatchArray) || tierMatchArray.length === 0) {
        // Handle empty or non-array case
        return null;
    }

    for (const tier of tierMatchArray) {
        const tierData = tier.tier;
        const hasProductType = tierData.discountProductTypes.includes(productType);
        const hasProductVendor = tierData.discountVendorTypes.includes(productVendor);

        if (hasProductType && hasProductVendor && lodgeCoupan) {
            return tierData;
        }
    }

    // If no match is found
    return null;
}

  function findMatchingTiermeber(productType, productVendor, tierMatchArray) {
    // var addtionalDiscount = getCookie('additionalDiscount');
    if (!Array.isArray(tierMatchArray) || tierMatchArray.length === 0) {
        // Handle empty or non-array case
        return null;
    }

    for (const tier of tierMatchArray) {
        const tierData = tier.tier;
        const hasProductType = tierData.discountProductTypes.includes(productType);
        const hasProductVendor = tierData.discountVendorTypes.includes(productVendor);

        if (hasProductType && hasProductVendor && !lodgeCoupan) {
            return tierData;
        }
    }

    // If no match is found
    return null;
}
  
    var TieredPricingCart = function (cartObject, isUpdate, bundleTier) {
      let memberPriceShowing = 0; 
       merberTiers = [];
       let productTypeAndVendorobj =  globalFields.productTypeAndVendor();
       let tiermatch = productTypeAndVendorobj.memberTierObj;
        for (let njk = 0; njk < globalFieldsCartPage_AC.cartTiersArray.length; njk++) {
           let tempTierProductsobjmember = {};
           let item = globalFieldsCartPage_AC.cartTiersArray[njk];
           let isFoundMember = TierMemberProducts.some(element => { if (element.VarientID === item.variant_id) { return true; } return false; });
           let productType = globalFieldsCartPage_AC.cartTiersArray[njk].product_type;
           let productVendor = globalFieldsCartPage_AC.cartTiersArray[njk].vendor;
           let matchedTier = findMatchingTier(productType, productVendor, tiermatch);
           let mebermatchedTier = findMatchingTiermeber(productType, productVendor, tiermatch);
          
           
          if (matchedTier) {
           merberTiers.push(true);
           let discountAmount = matchedTier.bundlewithVendorDiscount;
           let discountStatus = matchedTier.tier_status;
          let tierOffPrice = Number(discountAmount)
           let originalPriceCut = (( tierOffPrice/ 100) * (item.original_price / 100));
             originalPriceCut = (originalPriceCut * 100) / 100;
           let memberupdatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
           let memberupdatedLinePrice = globalFields.ConvertToFixedDecimalNumber(memberupdatedItemPrice * item.quantity);
           UpdateCartItem(item, memberupdatedItemPrice, memberupdatedLinePrice, false, true, njk);
              if (!isFoundMember) {
                    tempTierProductsobjmember['Discountvalue'] = discountAmount;
                    tempTierProductsobjmember['DiscountType'] = "percentage";
                    tempTierProductsobjmember['VarientID'] = item.variant_id;
                    tempTierProductsobjmember['DiscountText'] = 'Bricks';
                   
                }
                if (!isFoundMember) {
                    TierMemberProducts.push(tempTierProductsobjmember);
                }
          }
          if (mebermatchedTier) {
            
           let discountAmount = mebermatchedTier.bundlewithVendorDiscount;
           let discountStatus = mebermatchedTier.tier_status;
          let tierOffPrice = Number(discountAmount)
           let originalPriceCut = (( tierOffPrice/ 100) * (item.original_price / 100));
             originalPriceCut = Math.floor(originalPriceCut * 100) / 100;
           let memberupdatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
           let memberupdatedLinePrice = globalFields.ConvertToFixedDecimalNumber(memberupdatedItemPrice * item.quantity);
             memberPriceShowing += memberupdatedLinePrice;
          // UpdateCartItem(item, memberupdatedItemPrice, memberupdatedLinePrice, false, true, njk);
          }else{
            memberPriceShowing += globalFields.ConvertToFixedDecimalNumber((item.original_price / 100) * item.quantity);
          }
        }
        
      
      
        TierProducts = [];
        cartObject.items.sort((a, b) => {
        const productTypeA = a.product_type.toLowerCase();
        const productTypeB = b.product_type.toLowerCase();
        
        const priceA = a.price;
        const priceB = b.price;
        
        // First, sort based on product_type
        if (productTypeA < productTypeB) {
        return -1;
        } else if (productTypeA > productTypeB) {
        return 1;
        } else {
        // If product_type is the same, then sort based on price
        return priceA - priceB;
        }
        });
        jQuery('.line-item__discount-badge.discount-badge').remove()
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true;
            var itemTiers = undefined; if (TierObject != '' && TierObject != undefined) { itemTiers = matchTierObj(TierObject, item.product_type); } else { itemTiers = undefined; }
            if (itemTiers != undefined && itemTiers.tier_status) {
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k, bundleTier);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
               
                if (rslt[1]) {
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
            }
            else {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                // UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k);
            }
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }
        let totalAmount = jQuery('.line-item__price-list-container.text--right .mainpriceItem,.line-item__price-list-container.text--right .lastPriceFinal');
        let sum = 0;
        for (let index = 0; index < totalAmount.length; index++) {
        let updatePrice = totalAmount?.[index]?.innerText ?? "0";
        let numericPrice = parseInt(updatePrice.replace(/[^\d]/g, ''));
          numericPrice = (numericPrice / 100);
        // let numericPrice = parseFloat(updatePrice.replace(/[^0-9.-]+/g, "")); // Remove non-numeric characters
        sum += numericPrice ; // Add to the sum
        }
       if(sum != 0){
         console.log(globalFields.ConvertToFixedDecimalNumber(sum));
         let mainPriceSet =  globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100)
         let secondmainPirce = globalFields.ConvertToFixedDecimalNumber(sum);
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(sum), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
       }
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
        var nonorignalTotal = globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100);
        var memberorignalTotal = globalFields.ConvertToFixedDecimalNumber(memberPriceShowing);
        priceValue = (nonorignalTotal - memberorignalTotal)
       if(priceValue == 0){
         jQuery('#memberSave').hide();
         jQuery('#memberMessage').hide();
       }else{
         jQuery('#memberSaveSpan').text(globalFields.formatMoney(priceValue * 100, globalFields.amount));
        // jQuery('#memberSave').css("display","block");
        // jQuery('#memberMessage').css("display","block");
       }
       jQuery('.cart__recap button[name="checkout"]').prop('disabled', false);
        jQuery('.checkout-buttonText').text('Checkout');
       
    } //  Tier Object
   
  
  var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    } // DiscountCodeCookie 

   var isVariantIdMatch = function (variantIdToCheck,macth) {
    // Check if any item in the array has the specified variant_id
    return macth.some(item => Number(item.variant_id) == variantIdToCheck);
}
  
    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index, bundleTier) {
        let isFound = TierProducts.some(element => { if (element.VarientID === item.variant_id) { return true; } return false; });
        var allVariantItemQty = 0;
        let tempTierProductsobj = {};
      // * bundleTier.count
        var tierPrice = parseFloat(itemTiers.discountValue != "" ? (itemTiers.discountValue) : 0);
        var updatedItemPrice = 0, updatedLinePrice = 0;
        if (tierPrice != 0) { 
          
              let Maacthresult = isVariantIdMatch(item.variant_id,productsTypeArray);
              // console.log(Maacthresult); // Output: true
            if (itemTiers.productType == item.product_type) {
                var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                if (!isFound) {
                    tempTierProductsobj['Discountvalue'] = tierPrice;
                    tempTierProductsobj['DiscountType'] = "percentage";
                    tempTierProductsobj['VarientID'] = item.variant_id;
                    tempTierProductsobj['DiscountText'] = 'Bricks';
                    tempTierProductsobj['disCountQty'] = bundleTier.count;
                }
                if (!isFound) {
                    TierProducts.push(tempTierProductsobj);
                }
            }
            if (updatedItemPrice < 0) { updatedItemPrice = 0; }
            if(itemTiers.productType == item.product_type){
              if(bundleTier.count == item.quantity){
                 isNotInRange = false;
                bundleTier.count = bundleTier.count - item.quantity;
            updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
            updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
           // UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
              }else if(item.quantity > bundleTier.count && bundleTier.count != 0){
                 isNotInRange = false;
                  
                  let disQty = 0;
                  let nondisQty = 0;
                  nondisQty = (item.quantity) - (bundleTier.count);
                 disQty = (item.quantity) - nondisQty;
                if(bundleTier.count == 1){
                  bundleTier.count = 0;
                } else if(bundleTier.count > item.quantity) {
                  bundleTier.count = bundleTier.count - item.quantity;
                } else if(bundleTier.count < item.quantity) {
                   bundleTier.count = item.quantity - bundleTier.count;
                }
                  
                let firstPrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * disQty);
                let productOriginal = globalFields.ConvertToFixedDecimalNumber((item.original_price /100));
                let SecondPrice = globalFields.ConvertToFixedDecimalNumber(productOriginal * nondisQty);
                updatedLinePrice = firstPrice + SecondPrice;
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                 //UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
               
              }else if(item.quantity < bundleTier.count && bundleTier.count != 0){
                 isNotInRange = false;
                bundleTier.count = bundleTier.count - item.quantity;
              updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
            updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
            //UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
              }
            }
            // else{
            // updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
            // updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
            // UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
            // }
            // updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
            // updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
            // UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);

        }

        if (isNotInRange) {
            //UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
        }
        return [updatedTotalPrice, isNotInRange];
    } // CalculateTier Function

   function areQuantitiesSame(arr) {
  // Use Set to store unique quantity values
  let quantitySet = new Set();

  // Iterate through the array
  for (let item of arr) {
    // Add the quantity to the Set
    quantitySet.add(item.quantity);
  }

  // If the size of the Set is 1, it means all quantities are the same
  return quantitySet.size === 1;
}

    function sumQuantities(cart) {
    let totalQuantity = 0;

    for (let i = 0; i < cart.length; i++) {
        totalQuantity += parseInt(cart[i].quantity, 10);
    }

    return totalQuantity;
}
  
   var findHighestPriceByProductType = function (productType,array,bundleCount) {
   // Filter the array to get objects with the specified product type
    const filteredArray = array.filter(obj => obj.product_type === productType);
    // If there are matching objects, sort them by priceitem in ascending order
    if (filteredArray.length > 0) {
       let isQuantitySame = areQuantitiesSame(filteredArray);
      let totalQuantity = sumQuantities(filteredArray);
        if(isQuantitySame && totalQuantity == bundleCount ){
          productsTypeArray = filteredArray;
           return filteredArray[0];
        }else {
        const sortedArray = filteredArray.sort((a, b) => a.priceitem - b.priceitem);
          sotertDisObj = sortedArray;
        return sortedArray[0]; // Return the object with the lowest price
        }
    } else {
        return null; // Return null if no matching objects found
    }
   }

  
      function manageAdditionalDiscountCookie(data_) {
    const cookieName = "additionalDiscountarray";
    let existingDiscounts = getCookie(cookieName); // Get existing cookies array
   if(!existingDiscounts){
     existingDiscounts = [];
   }else{
     existingDiscounts = JSON.parse(existingDiscounts);
   }
    // Check if the discount already exists
    const isDuplicate = existingDiscounts.some((item) =>
        item.title === data_.title
    );

    // If not a duplicate, add to the array and update the cookie
    if (!isDuplicate) {
        existingDiscounts.push({
            value: data_.value,
            value_type: data_.value_type,
            target_type: data_.target_type,
            title: data_.title
        });
        SetCookie(cookieName, JSON.stringify(existingDiscounts), 90); // Save updated array in cookie
    }
}
  
    var pageLoadDiscount = function () {
        // URL
        var url = 'https://wholesale.apptiv.in/api/discountTierBundleTier?Shop=bricks-masons.myshopify.com';
        // Make GET request
        $.ajax({
            type: 'GET',
            url: url,
            success: function (response) {
                if (response.length > 0) {
                    if (response[0].MaxBundleTier != undefined) {
                        let cartProductsArrayObj = globalFields.cartItemProductType();
                        let bundleArray = response[0].MaxBundleTier.discountProductTypes;
                        let result = bundleGroup(cartProductsArrayObj, bundleArray);
                        let filteredArray = response[0].MaxBundleTier.bundlewithDiscount.filter(item => item.discountValue !== "");
                        if(filteredArray.length > 0){
                           
                           for (let mmm = 0; mmm < filteredArray.length; mmm++) {
                             
                             let discountBundle = findHighestPriceByProductType(filteredArray[mmm].productType,cartProductsArrayObj,result.count);
                            let issFound = true;
                             if(productsTypeArray.length > 0){
                              issFound = productsTypeArray.some(element => { if (element.variant_id === discountBundle.variant_id) { return true; } return false; });
                             }
                            
                             if(!issFound){
                             productsTypeArray.push(discountBundle);
                             }
                           }
                           
                        }
                       
                        if (result.allProductTypesPresent) {
                            TierObject = response[0].MaxBundleTier;
                            firstTimeLoad = response[0].MaxBundleTier;
                            TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);
                        } else {
                            TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                        }
                    }
                } else {
                    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                }
            },
            error: function (xhr, status, error) {
                // Handle errors here
                console.error('Error:', xhr, status, error);
            }
        });


      
    } // Api send Data 
    // var FetchCartTiers = function () {
    //     jQuery.ajax({
    //         async: false,
    //         url: "/cart/?view=ac_cart_tiers",
    //         success: function (result) {
    //             globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
    //         },
    //         error: function (e) { console.log(e.statusText); }
    //     });
    // } //  Fetch Cart Function

    // jQuery(document).ajaxComplete(function (event, xhr, settings) {
    //     ProcessCartResponse(settings.url, xhr.responseText);
    // });

    // var ProcessCartResponse = function (splittedUrl, responseText) {
    //     if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
    //         splittedUrl = splittedUrl.split("?");
    //         if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
    //             globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
    //             setTimeout(function () {
    //                 FetchCartTiers();
    //             }, 800);
    //         }
    //     }
    // }

    // try {
    //     var nativeFetch = window.fetch;
    //     window.fetch = function (...args) {
    //         if (args[0].includes("/cart/change") || args[0].includes("/cart/add")) {
    //             setTimeout(function () {
    //                 fetch('/cart.js')
    //                     .then(r => r.json().then(data => ({ status: r.status, body: data })))
    //                     .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
    //             }, 500);
    //         }
    //         return nativeFetch.apply(window, args);
    //     }
    // }
    // catch (e) { }

    function areAllItemsInBundle(cartProductsArrayObj, bundleArray) {
        // Check if all items in bundleArray are present in cartProductsArrayObj
        const allItemsInBundle = bundleArray.every(item =>
            cartProductsArrayObj.some(product => product.product_type === item)
        );
        return allItemsInBundle;
    }

 let AdditonalDiscountObj = {};

    var ValidateCode = function () {
        jQuery('button[name="ac-additional-discount-btn"]').text('Loading...');
        var discountCodeInput = $('#ac-additional-discount-text');
        var validInvalidCodeMsg = $('#ac-additional-valid-invalid-code');
        validInvalidCodeMsg.html('');
        var discountCode = discountCodeInput.val().trim();
     
        if (discountCode !== "") {
            var shop = 'bricks-masons.myshopify.com';
            GetCodeBundle(shop, discountCode);
           if(discountFlag){
              validInvalidCodeMsg.text(`couldn't be used with your existing discounts.`);
              jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
           }
           else if (TierObject !== undefined && newCodeClick && TierObject.tier_status) {
                var cartProductsArrayObj = globalFields.cartItemProductType();
                var bundleArray = TierObject.discountProductTypes;
                var result = bundleGroup(cartProductsArrayObj, bundleArray);
               let filteredArray = TierObject.bundlewithDiscount.filter(item => item.discountValue !== "");
                        if(filteredArray.length > 0){
                           for (let mmm = 0; mmm < filteredArray.length; mmm++) {
                             let discountBundle = findHighestPriceByProductType(filteredArray[mmm].productType,cartProductsArrayObj,result.count);
                              let issFound = true;
                             if(productsTypeArray.length > 0){
                              issFound = productsTypeArray.some(element => { if (element.variant_id === discountBundle.variant_id) { return true; } return false; });
                             }
                             if(!issFound){
                             productsTypeArray.push(discountBundle);
                             }
                           }
                           
                        }
                if (result.allProductTypesPresent) {
                    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);
                    // CartPageDiscountCoupens();
                   discountCode = discountCode.toUpperCase();
                  
                   $.ajax({
                    type: "POST",
                    async: false,
                    url: "https://wholesale.apptiv.in/tier/ACPGenerateAdditionalCode",
                    data: {
                        DiscountCode: discountCode,
                        CustomerId: customer_id,
                        Subtotal: globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100)
                    },
                    success: function (data_) {
                        if (data_.IsValid && data_.ValidDate) {
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                              AdditonalDiscountObj.target_type = data_.target_type;
                              AdditonalDiscountObj.title = data_.title;
                            var tempMsg = discountCodeInput.val().trim();
                            additionaltext = tempMsg;
                            var additionalDiscount = getCookie('additionalDiscount');
                            additionalDiscount = additionalDiscount ? additionalDiscount.split(',') : [];
                            tierbundle();
                            if (!additionalDiscount.includes(tempMsg)) {
                                additionalDiscount.push(tempMsg);
                                SetCookie("additionalDiscount", additionalDiscount, 90);
                              
                              if(data_.target_selection == "all"){
                              manageAdditionalDiscountCookie({
                              value : data_.value,
                              value_type : data_.value_type,
                              target_type  :data_.target_type,
                              title : data_.title
                              });
                                }
                                validInvalidCodeMsg.text('Discount Code Applied Succesfully..');
                                CartPageDiscountCoupens();
                             
                            } else {
                                validInvalidCodeMsg.text('Already Applied Discount Code');
                            }

                            discountCodeInput.val('');
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        } else {
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                            validInvalidCodeMsg.text('Please Enter a Valid Discount Code Coupons');
                        }
                    },
                    error: function (e) {
                        jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        console.log(e.statusText);
                    }
                });

                    discountCodeInput.val('');
                    jQuery('button[name="ac-additional-discount-btn"]').text('Apply');

                } else {
                  
                     $.ajax({
                    type: "POST",
                    async: false,
                    url: "https://wholesale.apptiv.in/tier/ACPGenerateAdditionalCode",
                    data: {
                        DiscountCode: discountCode,
                        CustomerId: customer_id,
                        Subtotal: globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100)
                    },
                    success: function (data_) {
                        if (data_.IsValid && data_.ValidDate) {
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                              AdditonalDiscountObj.target_type = data_.target_type;
                              AdditonalDiscountObj.title = data_.title;
                            var tempMsg = discountCodeInput.val().trim();
                            additionaltext = tempMsg;
                            var additionalDiscount = getCookie('additionalDiscount');
                            additionalDiscount = additionalDiscount ? additionalDiscount.split(',') : [];
tierbundle();
                            if (!additionalDiscount.includes(tempMsg)) {
                                additionalDiscount.push(tempMsg);
                                SetCookie("additionalDiscount", additionalDiscount, 90);
                              
                              if(data_.target_selection == "all"){
                              manageAdditionalDiscountCookie({
                              value : data_.value,
                              value_type : data_.value_type,
                              target_type  :data_.target_type,
                              title : data_.title
                              });
                              }
                                validInvalidCodeMsg.text('Discount Code Applied Succesfully..');
                                CartPageDiscountCoupens();
                              

                            } else {
                                validInvalidCodeMsg.text('Already Applied Discount Code');
                            }

                            discountCodeInput.val('');
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        } else {
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                            validInvalidCodeMsg.text('Please Enter a Valid Discount Code Coupons');
                        }
                    },
                    error: function (e) {
                        jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        console.log(e.statusText);
                    }
                });

                }
            }
            else {
              
                $.ajax({
                    type: "POST",
                    async: false,
                    url: "https://wholesale.apptiv.in/tier/ACPGenerateAdditionalCode",
                    data: {
                        DiscountCode: discountCode,
                        CustomerId: customer_id,
                        Subtotal: globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100)
                    },
                    success: function (data_) {
                        if (data_.IsValid && data_.ValidDate) {
                           
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                              AdditonalDiscountObj.target_type = data_.target_type;
                              AdditonalDiscountObj.title = data_.title;
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                            var tempMsg = discountCodeInput.val().trim();
                            var additionalDiscount = getCookie('additionalDiscount');
                            additionalDiscount = additionalDiscount ? additionalDiscount.split(',') : [];
tierbundle();
                            if (!additionalDiscount.includes(tempMsg)) {
                                additionalDiscount.push(tempMsg);
                                SetCookie("additionalDiscount", additionalDiscount, 90);
                              
                              if(data_.target_selection == "all"){
                              manageAdditionalDiscountCookie({
                              value : data_.value,
                              value_type : data_.value_type,
                              target_type  :data_.target_type,
                              title : data_.title
                              });
                              }
                                validInvalidCodeMsg.text('Discount Code Applied Succesfully..');
                                CartPageDiscountCoupens();
                           

                            } else {
                                validInvalidCodeMsg.text('Already Applied Discount Code');
                            }

                            discountCodeInput.val('');
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        } else {
                            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                            validInvalidCodeMsg.text('Please Enter a Valid Discount Code Coupons');
                        }
                    },
                    error: function (e) {
                        jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        console.log(e.statusText);
                    }
                });
            }
         // window.location.reload()
           // tierbundle();
        } else {
            CartPageDiscountCoupens();
            validInvalidCodeMsg.text('Please Enter Discount Code');
            jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
             
        }
    }



    var CartPageDiscount = function () {
        jQuery('#ac-additional-discount-btn').click(function (e) {
            jQuery('button[name="ac-additional-discount-btn"]').text('Loading...');
           
            ValidateCode();
        });
    }

    function getCookie(cookieName) {
        const cookies = document.cookie.split('; ');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].split('=');
            if (cookie[0] === cookieName) {
                return decodeURIComponent(cookie[1]);
            }
        }
        return null;
    }

   const handleLodgeMember = async function (Shop, codevalue) {
    var url = `https://wholesale.apptiv.in/api/getDiscountCouponsList?Shop=${Shop}&discountCode=${codevalue}`;
    
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url: url,
            success: function (response) {
                if (response.status == "success") {
                    resolve(response.message);
                } else {
                    resolve(response.message);
                }
            },
            error: function (xhr, status, error) {
                reject(false);
            }
        });
    });
};
  
    var GetCodeBundle = function (Shop, codevalue) {
        jQuery.ajax({
            type: "POST", async: false, url: "https://wholesale.apptiv.in/api/discountTierBundle",
            data: { discountCouponCodes: codevalue, Shop: Shop },
            success: async function (result) {
               var memberDiscountFlag = false;
               var memberShipDiscount = await handleLodgeMember(Shop, codevalue);
                 if(result.BundleTiers.length != 0){
                   lodgeCoupan = true;
                  const arrayvalue = result.BundleTiers[0].discountBundelArray;
                  const passValue = firstTimeLoad.maxDiscountValue;
                  const resultsisValueGreaterThanHighest = isValueGreaterThanHighest(arrayvalue, passValue);
                  if(resultsisValueGreaterThanHighest){
                   TierObject = firstTimeLoad;
                   discountFlag = true;
                  }else{
                  TierObject = result.BundleTiers.length > 0 ? result.BundleTiers[0] : undefined;
                   discountFlag = false;
                  }
                 }
                 else if(result.BundleTiers.length == 0 && !memberDiscountFlag && memberShipDiscount){
                   lodgeCoupan = true;
                   memberDiscountFlag = true;
                   TierObject = undefined;
                 }
                 else if(firstTimeLoad != ''){
                   TierObject = firstTimeLoad;
                   newCodeClick = false;
                 }
                 else{
                   TierObject = undefined;
                   newCodeClick = false;
                   
                 }
                 
            },
            error: function (e) { console.log(e.statusText); }
        });
    } // On Click Discount Button 

    function cancelDiscount(id) {
        setTimeout(function () {
          
            var addtionalDiscount = getCookie('additionalDiscount');
            var additionalDiscountarrayValue = getCookie('additionalDiscountarray');
          
            if (addtionalDiscount != null) {
                var addtionalDiscountvalue = addtionalDiscount.split(',');
              additionalDiscountarrayValue = JSON.parse(additionalDiscountarrayValue);
                addtionalDiscountvalue.splice(id, 1);
                additionalDiscountarrayValue.splice(id, 1);
                if (addtionalDiscountvalue.length == 0) {
                    jQuery('.anncodeDiscount').remove();
                    deleteCookie('additionalDiscount');
                    deleteCookie('additionalDiscountarray');
                  
                } else {
                    SetCookie("additionalDiscount", addtionalDiscountvalue, 90);
                    SetCookie("additionalDiscountarray", additionalDiscountarrayValue, 90);
                    CartPageDiscountCoupens();
                }
            }
          location.reload();
        }, 500);
    } // Delete discount code 

    var tierbundle = function () {
        var addtionalDiscount = getCookie('additionalDiscount');
        if (addtionalDiscount != null) {
          
            var addtionalDiscountvalue = addtionalDiscount.split(',');
            for (let kl = 0; kl < addtionalDiscountvalue.length; kl++) {
                var shop = 'bricks-masons.myshopify.com';
                GetCodeBundle(shop, addtionalDiscountvalue[kl]);
                if (TierObject != undefined) {
                      $.ajax({
                    type: "POST",
                    async: false,
                    url: "https://wholesale.apptiv.in/tier/ACPGenerateAdditionalCode",
                    data: {
                        DiscountCode: addtionalDiscountvalue[kl],
                        CustomerId: customer_id,
                        Subtotal: globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100)
                    },
                    success: function (data_) {
                        if (data_.IsValid && data_.ValidDate) {
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                              AdditonalDiscountObj.target_type = data_.target_type;
                              AdditonalDiscountObj.title = data_.title;
                         // tierbundle();
                        }
                    },
                    error: function (e) {
                        jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        console.log(e.statusText);
                    }
                });
                    let cartProductsArrayObj = globalFields.cartItemProductType();
                    let bundleArray = TierObject.discountProductTypes;
                    let result = bundleGroup(cartProductsArrayObj, bundleArray);
                     let filteredArray = TierObject.bundlewithDiscount.filter(item => item.discountValue !== "");
                        if(filteredArray.length > 0){
                           for (let mmm = 0; mmm < filteredArray.length; mmm++) {
                             let discountBundle = findHighestPriceByProductType(filteredArray[mmm].productType,cartProductsArrayObj,result.count);
                             let issFound = true;
                              if(productsTypeArray.length > 0){
                              issFound = productsTypeArray.some(element => { if (element.variant_id === discountBundle.variant_id) { return true; } return false; });
                              }
                             if(!issFound){
                             productsTypeArray.push(discountBundle);
                             }
                           }
                           
                        }

                    if (!result.allProductTypesPresent) {
                        // cancelDiscount(kl);
                        TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);

                    }
                    if (result.allProductTypesPresent) {
                        TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);
                    }
                } else {
                  
                    if(addtionalDiscountvalue[kl] != null && addtionalDiscountvalue[kl] != undefined){
                           $.ajax({
                    type: "POST",
                    async: false,
                    url: "https://wholesale.apptiv.in/tier/ACPGenerateAdditionalCode",
                    data: {
                        DiscountCode: addtionalDiscountvalue[kl],
                        CustomerId: customer_id,
                        Subtotal: globalFields.ConvertToFixedDecimalNumber(globalFieldsCartPage_AC.cartObj.original_total_price / 100)
                    },
                    success: function (data_) {
                        if (data_.IsValid && data_.ValidDate) {
                              AdditonalDiscountObj.value = data_.value;
                              AdditonalDiscountObj.value_type = data_.value_type;
                              AdditonalDiscountObj.target_type = data_.target_type;
                              AdditonalDiscountObj.title = data_.title;
                            // tierbundle();
                        }
                    },
                    error: function (e) {
                        jQuery('button[name="ac-additional-discount-btn"]').text('Apply');
                        console.log(e.statusText);
                    }
                });
                    }
                    let result = {}
                    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);
                }
            }
        } else {
            pageLoadDiscount();
           // TieredPricingCart(globalFieldsCartPage_AC.cartObj, true, result);

        }

    }
    setTimeout(function () {
     tierbundle();
      }, 1000);

    var CartPageDiscountCoupens = function () {
        setTimeout(function () {
            jQuery('.anncodeDiscount').remove()
            var addtionalDiscount = getCookie('additionalDiscount');
            if (addtionalDiscount != null) {
                var addtionalDiscountvalue = addtionalDiscount.split(',');
                array = addtionalDiscountvalue;
                let str = '';
                if (addtionalDiscountvalue.length > 0) {
                    for (let jk = 0; jk < addtionalDiscountvalue.length; jk++) {
                        str += `<span class='anncodeDiscount' >
  <span>
  <svg style="max-width: 13;max-height: 13px;" class="icon-svg icon-svg--color-adaptive-light icon-svg--size-16 reduction-code__icon" aria-hidden="true" focusable="false"> <use xlink:href="#tags-filled"><svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg></use></svg>
  </span>
  <span class='anncodeDiscountBundle'>${addtionalDiscountvalue[jk]}</span>
  <span  onclick="cancelDiscount(${jk})" style="color: red;cursor: pointer">X</span>
</span>`
                    }
                }
                // console.log('str',str)
                jQuery('#ac-additional-amount-off').append(str)
            }
   jQuery('.cart__discount-list.list--unstyled').remove();
          
        }, 500);
    } // Previous Discount Code

 var perfEntries = performance.getEntriesByType("navigation");
if (perfEntries[0].type === "back_forward") {
    location.reload();
}
    window.onload = function() {
    //handleDiscount(); 
    tierbundle();
    jQuery('.cart__recap button[name="checkout"]').prop('disabled', false);
   jQuery('.checkout-buttonText').text('Checkout');
  };
  if(loadingCheck){
   jQuery('.cart__recap button[name="checkout"]').prop('disabled', false);
   jQuery('.checkout-buttonText').text('Checkout');
  }
  async function handleDiscount() {
  try {
    const response = await fetch("/discount/CLEAR");

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const contentType = response.headers.get("Content-Type");

    if (contentType && contentType.includes("application/json")) {
      const data = await response.json();
      console.log("Discount data:", data);
      // Continue processing or updating the UI as needed
    } else {
      // Handle non-JSON content, such as HTML or other types
      // console.error("Unexpected content type:", contentType);
      // Handle specific error scenarios or display a user-friendly message
    }
  } catch (error) {
    // Handle errors
    // console.error("Error fetching discount:", error.message);
    // Handle specific error scenarios or display a user-friendly message
  }
}
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }
    pageLoadDiscount(); CheckoutClickCart(); CheckoutClickAjax(); CartPageDiscount(); CartPageDiscountCoupens();
  
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();